"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
exports.DateFilterHeader = function (_a) {
    var children = _a.children, changeRoute = _a.changeRoute, otherProps = tslib_1.__rest(_a, ["children", "changeRoute"]);
    return (react_1.default.createElement("button", tslib_1.__assign({ className: "gd-extended-date-filter-header s-do-not-close-dropdown-on-click", onClick: function (e) {
            e.preventDefault();
            changeRoute(null);
        } }, otherProps),
        react_1.default.createElement("span", { className: "gd-icon-navigateleft" }),
        "\u2003",
        children));
};
//# sourceMappingURL=DateFilterHeader.js.map